import { createContext, useContext } from "react";

/**
 * Where non-Radix popups (react-select menus and the like) should portal.
 * A modal Radix surface disables pointer events outside its content and
 * dismisses on pointerdown there, so a menu portaled to `document.body`
 * from inside one can't be used.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement {
  return useContext(PortalContainerContext) ?? document.body;
}
